import { useContext } from 'react';
import { FlexAlignStart, FlexColumn } from '../shared/Flex';
import { Text } from '../ui-elements/Main/Text';
import { SpanLink } from '../ui-elements/Main/SpanLink';
import styled from 'styled-components';
import { colors } from '../ui-elements/Main/MainTheme';
import { UserInfoContext } from '../user/user-info';
import { Avatar } from './Avatar';
import { useNavigationActions } from '@/lib/navigation';

export const MenuProfile = () => {
  const { name, email } = useContext(UserInfoContext);
  const { navigate } = useNavigationActions();
  return (
    <Container>
      <Avatar />
      <InfoColumn>
        <Text fontSize="14px" fontWeight={600}>{name}</Text>
        <EmailText fontSize="12px" margin="0 0 2px">{email}</EmailText>
        <SpanLink
          style={{ fontSize: '12px' }}
          onClick={() => navigate({ path: `${origin}/profile`, params: {} })}
        >
          Edit Profile
        </SpanLink>
      </InfoColumn>
    </Container>
  );
};

const Container = styled(FlexAlignStart)`
  padding: 20px 20px 12px 20px;
  border-bottom: 1px solid ${colors.greyer};
  gap: 10px;

  .avatar-image {
    margin-right: unset !important;
  }
`;

const InfoColumn = styled(FlexColumn)`
  min-width: 0;
`;

const EmailText = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
`;
